import { NetworkService } from '../../services/NetworkService'

import { User } from '../../models/User'

import axios from 'axios'


const mutations = {
  setAuthenticated (state: any, value: boolean) {
    state.authenticated = value
  },
  setCurrentUser (state: any, user: User) {
    state.currentUser = user
  },
  clearCurrentUser (state: any) {
    state.currentUser = null
  }
}

const getters = {
  authenticated (state: any) {
    return state.authenticated
  },
  isDealerAdmin (state: any) {
    if (state.authenticated) {
      let bool = false
      state.currentUser.roles.forEach((role: any) => {
        if (role.name == 'dealer-admin' || role.name == 'admin') {
          bool = true
        }
      })
      return bool
    } else { return false }
  },
  isProductAdvisor (state: any) {
    if (state.authenticated) {
      let bool = false
      state.currentUser.roles.forEach((role: any) => {
        if (['admin', 'dealer-admin', 'product-advisor'].includes(role.name)) {
          bool = true
        }
      })
      return bool
    } else { return false }
  },
  isCustomer (state: any) {
    if (state.authenticated) {
      let bool = false
      state.currentUser.roles.forEach((role: any) => {
        if (role.name == 'customer') {
          bool = true
        }
      })
      return bool
    } else { return false }
  },
  currentUser (state: any) {
    if (state.authenticated) {
      return state.currentUser
    }
  } 
}

const actions = {
  async register (context: any, form: object) {
    try {
      const response = await NetworkService.post(process.env.VUE_APP_API_BASE_URL + '/api/register', form)
      return response.status
    } catch(error) {
      return -1
    }
  },
  async createUserWithoutPassword (context: any, form: object) {
    try {
      const response = await NetworkService.post(process.env.VUE_APP_API_BASE_URL + '/api/registerWithoutPassword', form)
      return response.data
    } catch (error) {
      return -1
    }
  },
  async createDealershipUser (context: any, form: object) {
    try {
      const response = await NetworkService.post(process.env.VUE_APP_API_BASE_URL + '/api/registerDealershipUser', form)
      return response.status
    } catch (error) {
      return -1
    }
  },
  async signIn (context: any, form: object) {
    try {
      const csrf_response = await NetworkService.get(process.env.VUE_APP_API_BASE_URL + '/sanctum/csrf-cookie')
      if (csrf_response.status === 204) {
        try {
          const response =  await NetworkService.post(process.env.VUE_APP_API_BASE_URL + '/api/login', form)
          if (response.status === 200) {
            const loginUser : User = new User(response.data)
            context.commit('setCurrentUser', loginUser)
            context.commit('setAuthenticated', true)
            context.dispatch('cart/loadCart', { customerId: loginUser.id }, { root: true })
            return response.status
          }
        } catch(error) {
          return -1
        }
      } 
    } catch (error) {
      return -1
    }
  
  },
  async signOut (context: any) {
    try {
      const response = await NetworkService.post(process.env.VUE_APP_API_BASE_URL + '/api/logout')
      context.commit('setAuthenticated', false)
      context.commit('clearCurrentUser')
      context.commit('cart/clearCart', null, { root: true })
      return response.status
    } catch (error) {
      return -1
    }
  },
  clearAuth (context: any) {
    context.commit('setAuthenticated', false)
    context.commit('clearCurrentUser')
    context.commit('cart/clearCart', null, { root: true })
  },
  async updateUser (context: any, form: object) {
    try {
      const response = await NetworkService.patch(process.env.VUE_APP_API_BASE_URL + '/api/v1/auth/user', form)
      return response.status
    } catch(error) {
      return -1
    }
  },
  async updateUserAsAdmin (context: any, form: object) {
    try {
      const response = await NetworkService.patch(process.env.VUE_APP_API_BASE_URL + '/api/v1/auth/user/updateUserAsAdmin', form)
      return response.status
    } catch(error) {
      return -1
    }
  },
  async updateCurrentUser (context: any, user: User) {
    context.commit('setCurrentUser', user)
  },
  async resetPasswordRequest (context: any, form: object) {
    try {
      const response = await NetworkService.post(process.env.VUE_APP_API_BASE_URL + '/api/reset-password-request', form)
      return response.status
    } catch (error) {
      return -1
    }
  },

  async resetPassword (context: any, form: object) {
    try {
      const response = await NetworkService.post(process.env.VUE_APP_API_BASE_URL + '/api/reset-password', form)
      return response.status
    } catch (error) {
      return -1
    }
  },
  async me (context: any) {
    try {
      const response = await axios.get(process.env.VUE_APP_API_BASE_URL + '/api/v1/auth/user/checkAuth')
      const loginUser : User = new User(response.data)
      context.commit('setCurrentUser', loginUser)
      context.commit('setAuthenticated', true)
      context.dispatch('cart/loadCart', { customerId: loginUser.id }, { root: true })
    } catch (error) {
      context.commit('setAuthenticated', false)
      context.commit('clearCurrentUser')
    }
  }

}

const state = () => ({
  authenticated: false as boolean,
  currentUser: null as (User | null)
})

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};
